// ===== LOGS DE FALHA FRONTEND =====
let _logThrottle=0,_logCount=0;
async function logErroFrontend(tipo,mensagem,{url='',linha=0,coluna=0,stack='',contexto=''}={}){
  if(!fdb)return; // Firebase não inicializado ainda
  const agora=Date.now();
  if(agora-_logThrottle>60000){_logThrottle=agora;_logCount=0}
  if(++_logCount>20)return; // máx 20 logs/minuto para evitar flood
  const authUser=typeof firebase?.auth==='function'?firebase.auth().currentUser:null;
  const sessao=sessionStorage.getItem('audit_session')||'?';
  try{
    await fdb.collection('_logs').add({
      timestamp:firebase.firestore.FieldValue.serverTimestamp(),
      tipo, // 'onerror'|'unhandledrejection'|'manual'
      mensagem:String(mensagem||'').slice(0,500),
      url:String(url||location.href).slice(0,200),
      linha,coluna,
      stack:String(stack||'').slice(0,2000),
      contexto:String(contexto||'').slice(0,200),
      usuarioId:authUser?.uid||null,
      usuario:authUser?.email||authUser?.displayName||null,
      sessao,
      userAgent:navigator.userAgent.slice(0,200),
      organizationId:window.MarmoriaSaaS?.state.organizationId||null,
    });
  }catch(_){/* falha silenciosa — não logar o log */}
}
window.addEventListener('error',event=>{
  if(!event.error&&!event.message)return;
  logErroFrontend('onerror',event.message,{url:event.filename,linha:event.lineno,coluna:event.colno,stack:event.error?.stack||''});
});

function parseFirebaseConfig(raw){
  let text=raw.trim().replace(/^\s*(?:const|let|var)\s+firebaseConfig\s*=\s*/,'').replace(/;\s*$/,'');
  try{return JSON.parse(text)}catch{}
  text=text.replace(/([{,]\s*)([A-Za-z_$][\w$]*)(\s*:)/g,'$1"$2"$3').replace(/'/g,'"');
  try{return JSON.parse(text)}catch{return null}
}

